import { ENUM__debug_feature_client } from '@/_debug/ENUM__debug_feature_client';
import animation_loading_grid_5x5 from '@/assets/animations/animation_loading_grid_5x5.svg?url';
import { HOOK_GRID2D_CELL__icon_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__icon_size';

interface PROPS {
  cell_width: number;
  cell_height: number;
}

export function GRID2D_CELL__loading_grid2d({ cell_width, cell_height }: PROPS) {
  /*
   * STATE
   */

  const { icon_width, icon_height } = HOOK_GRID2D_CELL__icon_size(cell_width, cell_height);
  const icon_side_min = Math.min(icon_width, icon_height);

  /*
   * RENDERS
   */

  function render_animation() {
    let out = null;

    if (!ENUM__debug_feature_client.ENABLE_SVG_ANIMATION_CELL_LOADING_GRID2D) return out;

    return (
      <img
        draggable={false}
        src={animation_loading_grid_5x5}
        alt="Loading animation"
        style={{ width: `${icon_side_min}px`, height: `${icon_side_min}px` }}
        className=" opacity-90 text-component"
      />
    );
  }

  return (
    <div
      className=" flex-center 
                  bg-component-item rounded-2xl 
                  border-[1px] border-bar-border bg-transparent relative cursor-loading"
      style={{ width: cell_width, height: cell_height, minWidth: cell_width, minHeight: cell_height }}
    >
      {render_animation()}
    </div>
  );
}
